var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosestTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2222 25C17.2222 29.2955 20.7045 32.7778 25 32.7778C29.2955 32.7778 32.7778 29.2955 32.7778 25C32.7778 20.7045 29.2955 17.2222 25 17.2222C20.7045 17.2222 17.2222 20.7045 17.2222 25ZM25 15C19.4772 15 15 19.4772 15 25C15 30.5228 19.4772 35 25 35C30.5228 35 35 30.5228 35 25C35 19.4772 30.5228 15 25 15Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3636 24.636V22.4542C25.3636 21.8517 24.8751 21.3633 24.2726 21.3633C23.6701 21.3633 23.1816 21.8517 23.1816 22.4542V25.7269C23.1816 26.3294 23.6701 26.8178 24.2726 26.8178H27.5452C28.1477 26.8178 28.6362 26.3294 28.6362 25.7269C28.6362 25.1244 28.1477 24.636 27.5452 24.636H25.3636Z",
    fill: "#F4F9FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosestTime);
export default __webpack_public_path__ + "static/media/closestTime.537491f0da31693491e092c55c481f3e.svg";
export { ForwardRef as ReactComponent };